/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Submissions } from '../../models/submissions';
import { SubmissionsCreate } from '../../models/submissions-create';

export interface CreateSubmissionApiV2SubmissionsOrgPost$Params {
  org: string;
  selfStart?: (boolean | null);
  mode?: ('upstream' | 'secretariat' | null);
      body: SubmissionsCreate
}

export function createSubmissionApiV2SubmissionsOrgPost(http: HttpClient, rootUrl: string, params: CreateSubmissionApiV2SubmissionsOrgPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Submissions>> {
  const rb = new RequestBuilder(rootUrl, createSubmissionApiV2SubmissionsOrgPost.PATH, 'post');
  if (params) {
    rb.path('org', params.org, {});
    rb.query('selfStart', params.selfStart, {});
    rb.query('mode', params.mode, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Submissions>;
    })
  );
}

createSubmissionApiV2SubmissionsOrgPost.PATH = '/api/v2/submissions/{org}';
